import React from 'react'
import { Dialog, DialogActions, Button, DialogTitle,DialogContent,DialogContentText } from '@material-ui/core'


class ConfirmShippedDialog extends React.Component {

    constructor() {
        super()
        this.state = {
            open: false 
        }        
    }



    handleDialogOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleConfirmItemShipped = () => {

        const { onConfirmItemShipped, item } = this.props

        this.setState({
            open: false
        })

        onConfirmItemShipped(item)
    }

    render() {

        

        return (
            <div>
                <Button size="medium"
                    color="primary"
                    onClick={this.handleDialogOpen}
                    variant="raised">
                    Confirm item shipped
                </Button>
    
    
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
    
                    <DialogTitle id="alert-dialog-title">{"Delivery Confirmation"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please confirm you shipped the item
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>       
                        <Button onClick={this.handleClose} color="primary" autoFocus>
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirmItemShipped} color="primary">
                            Confirm
                         </Button>                        
                    </DialogActions>
                </Dialog>
    
            </div>
        )        
    }
}


export default ConfirmShippedDialog


// WEBPACK FOOTER //
// ./src/components/ConfirmShippedDialog.js